<template>
  <div>
    <Breadcrumb :options="breadcrumb" />

    <div class="info_form">
      <el-form ref="form" :model="form" :label-width="labelWidth" :rules="rules" :inline="true">
        <div class="block">
          <div class="contit">{{ formGroups[0].title }}</div>

          <FormItem v-for="(c, i) in formGroups[0].formCtrl" :key="`formCtrl${i}_${c.name}_${!!c.disabled}`"
            :viewMode="viewMode" :config="c" :options="c.options" :inputValue="form[c.keyName]" @onChange="onChange"
            :class="c.className" />

          <FormItem v-show="form['iswork'] == 2" :viewMode="viewMode" :config="ctrl1" :options="ctrl1.options"
            :inputValue="form[ctrl1.keyName]" @onChange="onChange" :class="ctrl1.className" />
        </div>

        <div class="block">
          <div class="contit">{{ formGroups[1].title }}</div>

          <FormItem v-for="(c, i) in formGroups[1].formCtrl" :key="`formCtrl${i}_${c.name}_${!!c.disabled}`"
            :viewMode="viewMode" :config="c" :options="c.options" :inputValue="form[c.keyName]" @onChange="onChange"
            :class="c.className" />
        </div>

      </el-form>
    </div>

    <div class="btns">
      <SubmitBtn v-if="mode != 'view'" :editMode="mode === 'edit'" @onSubmit="onSubmit"></SubmitBtn>
      <CancelBtn :mode="mode" @onCancel="cancel"></CancelBtn>
    </div>
  </div>
</template>

<script>
import detailMixin from "../../mixin/detail";
import staffDetailMixin from "../mixin/detail";

export default {
  name: "StaffDriverDetail",
  mixins: [detailMixin, staffDetailMixin],
  data() {
    return {
      baseUrl: 'driver',
      breadcrumb: [
        { name: "人员管理", path: "/staff/driver" },
        { name: "司机管理", path: "/staff/driver" },
        { name: "添加司机" },
      ],
      form: {
        name: undefined,
        sex: '男',
        birthday: undefined,
        tel: undefined,
        nation: undefined,
        province: undefined,
        address: undefined,
        contact: undefined,
        contacttel: undefined,
        identitycard: undefined,
        basedriver: undefined,
        deposit: undefined,
        deposit_status_str: undefined,
        bank_name: undefined,
        cardholder: undefined,
        bank_card_no: undefined,
        username: undefined,
        password: undefined,
      },
      ctrl1: {
        label: "押金打款凭证",
        keyName: "deposit_pay_images",
        type: "file",
        tips: "最多上传2张图片",
        max: 2,
        className: "block",
      },
    };
  },
  methods: {
    setDetail() {
      const formCtrl = [...this.formGroups[0].formCtrl]
      if (this.formGroups[1]) {
        formCtrl.push(...this.formGroups[1].formCtrl)
      }
      formCtrl.map(v => {
        const key = v.keyName
        if (key === 'iswork') {
          console.log(key)
          this.form[key] = this.detail[key] + ''
          console.log({ ...this.form })
          if (this.form['iswork'] == '2') {
            this.formGroups[0].formCtrl.map(v => {
              if (v.keyName === 'deposit_status_str') {
                v.disabled = false
                console.log({ ...v })
              }
            })
          }
        } else {
          this.form[key] = this.detail[key];
        }
      })
      const { deposit_status } = this.detail
      if (deposit_status == 2) {
        this.form['deposit_status_str'] = '已扣除'
      } else if (deposit_status == 3) {
        this.form['deposit_status_str'] = '已归还'
      } else {
        this.form['deposit_status_str'] = '未扣除'
      }
      this.form['deposit_pay_images'] = this.detail['deposit_pay_images']
      this.$forceUpdate()
      // console.log({ ...this.detail })
      // console.log({ ...this.form })
    },
    paramsPackage(params, object) {
      for (const key in object) {
        if (Object.hasOwnProperty.call(object, key)) {
          // console.log(typeof object[key])
          const value = object[key]
          if (value && typeof value === 'object') {
            console.log(key, value)
            params[key] = value.map(v => {
              let result = v
              if (v.response && v.response.photo) {
                result = { url: v.response.photo }
              }
              return result
            })
          } else {
            params[key] = value;
          }
        }
      }
      delete params['deposit_status_str']

      const opt = this.id ? 'update' : 'create'

      params['headers'] = {
        'X-Method': opt,
        'X-Module': 'staff',
      }
    },
    setOptions({ iswork, edu, team, basedriver, roydriver }) {
      this.formGroups[0].formCtrl.map(c => {
        if (c.keyName == 'iswork' && iswork) {
          for (const key in iswork) {
            if (Object.hasOwnProperty.call(iswork, key)) {
              const val = iswork[key];
              c.options.push({
                label: val,
                value: key,
              })
            }
          }
          this.form.iswork = '1'
          // console.log([...c.options])
          // console.log({...this.form})
        }
        if (c.keyName == 'edu' && edu.length) {
          c.options = edu.map(v => {
            return {
              label: v.eduname,
              value: v.eduname,
            }
          })
          this.form.edu = edu[0].eduname
        }
        if (c.keyName == 'fleet' && team.length) {
          c.options = team.map(v => {
            return {
              label: v.nickname + '车队',
              value: v.id,
            }
          })
          this.form.fleet = team[0].id
        }
        if (basedriver && !this.form.basedriver) {
          this.form.basedriver = basedriver
        }
        if (roydriver && !this.form.roydriver) {
          this.form.roydriver = roydriver
        }
      })
    },
  },
  created() {
    this.formGroups[0].formCtrl.splice(12, 1,
      {
        label: "基本工资（元）",
        keyName: "basedriver",
        err: "请填写基本工资",
        type: "number",
      },
      {
        label: "押金金额（元）",
        keyName: "deposit",
        err: "请填写司机押金",
        type: "number",
      },
      {
        label: "押金状态",
        keyName: "deposit_status_str",
        err: "请选择押金状态",
        type: "select",
        disabled: true,
        options: [
          { label: '未扣除', value: '未扣除' },
          { label: '已扣除', value: '已扣除' },
          { label: '已归还', value: '已归还' },
        ],
      },
      {
        label: "开户银行",
        keyName: "bank_name",
        err: "请填写开户银行",
        type: "text",
        className: "instyle",
      },
      {
        label: "持卡人",
        keyName: "cardholder",
        err: "请填写持卡人",
        type: "text",
        className: "instyle",
      },
      {
        label: "银行账号",
        keyName: "bank_card_no",
        err: "请填写银行账号",
        type: "text",
        className: "instyle",
      },
    )

    this.rules['bank_name'] = [
      { required: true, message: "请填写开户银行", trigger: "blur" },
    ]
    this.rules['cardholder'] = [
      { required: true, message: "请填写持卡人", trigger: "blur" },
    ]
    this.rules['bank_card_no'] = [
      { required: true, message: "请填写银行账号", trigger: "blur" },
    ]

    this.getOptions();
  },
  mounted() { },
};
</script>

<style lang="less" scoped>
.info_form {
  background-color: #fff;
  padding-top: 20px;
  padding-bottom: 5px;
  border-radius: 5px;

  .contit {
    height: 24px;
    line-height: 24px;
    overflow: hidden;
    margin: 0 auto 25px;
    padding: 0 21px;
    font-weight: bold;
    font-size: 18px;
    color: #343434;
  }

  /deep/ .el-form {
    margin-bottom: 20px;

    .el-form-item {
      padding: 0 20px 0 0;
      margin-bottom: 20px;

      &.block {
        width: 100%;
        padding-right: 0;
        margin-right: 0;
      }

      .el-input,
      .el-date-editor--daterange {
        width: 300px;
      }

      .el-form-item__content {
        .el-input {
          width: 300px;
        }

        .unit {
          color: #909399;
        }

      }

    }
  }

  .el-form:last-child {
    margin-bottom: 0;
  }
}

.btns {
  padding: 40px 0 60px 180px;
}
</style>
